import React from "react";
import "./upper.scss";
import { useNavigate } from "react-router-dom";

const Upper = () => {
  const navigate = useNavigate();
  return (
    <div className="Upper">
      <video
        width="400"
        height="400"
        controls
        autoPlay
        poster="https://www.insynchcs.com/hubfs/mental-health-2019924_1920-1.jpg"
        className="randoms"
      >
        <source src="./Videos/video1.mp4" type="video/mp4" />
      </video>

      <div className="Buttons">
        <button>Create Room</button>
        <button
          onClick={() => {
            navigate("/mainRoom");
          }}
        >
          Join Room
        </button>
        <button>Create Blog</button>
      </div>
    </div>
  );
};

export default Upper;
